<template>
  <a class="lo-btn lo-btn--secondary lo-btn--lg lo-btn--expand" @click.prevent="$emit('click')">
    <span v-html="text" />
  </a>
</template>


<script>

    export default {
        props: {
            text: {
                default: "",
                type: String,
            }
        }
    }
</script>

<style>

</style>
